import { baseUrl } from "features/api";

export const usersUrl = `${baseUrl}users/`;
